import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import PaginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { useLocation, useNavigate } from "react-router-dom";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import Select from "react-select";
import SideBar from "../../Components/Navbar/Sidebar";
import "./Media.css";
import instance from "../../Components/Apis/axios";
import pptxgen from "pptxgenjs";
import Loader from "../../Components/loader";
import Pajination from "../../helpingFiles/Pagination/Pajination";
import Head from "../../Components/ontabletop/head";
import { BiReset } from "react-icons/bi";
import { makeXlSX } from "../../Components/Apis/apis";
let pptx = new pptxgen();

const Media = () => {
  const filterForm = {
    subcategory: "",
    illumination: "",
    city_name: "",
    location: "",
    keyword: "",
  };
  const { ExportCSVButton } = CSVExport;
  let locations = useLocation();
  let navigation = useNavigate();
  const path = locations.pathname;
  const [selectedRows, setSelectedRows] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Users, fetchUsers] = useState([]);
  const [state, setState] = useState([]);
 const [exportingPpt,setExportingPpt]=useState(false);
  const [exportingExcl,setExportingExcl]=useState(false);
  const [formData, setFormData] = useState({});
  const [noStateData, setStateData] = useState("");
  const [mainData, setMainData] = useState([]);
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [postPerpage, setPostPerPage] = useState(10);
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState(filterForm);
  const [category, setCategory] = useState();
  const [subcategory, setSubCategory] = useState();
  const [Illu, setIllu] = useState();
  const [city, setCity] = useState();
  const [location, setLocation] = useState();
  const [keyword, setKeyword] = useState();

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

    const [excelFilters, setExcelFilters] = useState({
      code: true,
      state: true,
      thumb : true,
      city_name: true,
      category_name: true,
      location: true,
      geoloation: true,
      size: true,
      illumination: true,
      subcategory: true,
      price: true,
      mediaownercompanyname:true,
      phonenumber:true,
      email:true,
      mediaownername:true,
      latitude:true,
      longitude:true,
      
width
:true,
      height:true,
      heightunit:true,
      pricetype:true
    });
  
   const [pptFilters, setPptFilters] = useState({
      code: true,
      category_name: true,
      subcategory: true,
      illumination: true,
      city_name: true,
      location: true,
      latitude:true,
      longitude:true,
      size:true,
      price: true,
      pricetype:true
    });
  
      const handleExcelCheckboxChange = (filter) => {
      setExcelFilters((prevFilters) => {
        if (filter === "price") {
       
          return {
            ...prevFilters,
            price: !prevFilters.price,
            pricetype: !prevFilters.pricetype,
          };
        } else {
      
          return {
            ...prevFilters,
            [filter]: !prevFilters[filter],
          };
        }
      });
    };
  

    const handlePptCheckboxChange = (filter) => {
      setPptFilters((prevFilters) => {
        if (filter === "price") {
       
          return {
            ...prevFilters,
            price: !prevFilters.price,
            pricetype: !prevFilters.pricetype,
          };
        } else {
   
          return {
            ...prevFilters,
            [filter]: !prevFilters[filter],
          };
        }
      });
    };

  const showMedia= async (
    e
  ) => {
  
   setCategory(e)
   const category=e.value;
    setLoading(true);
    const { data } = await instance.post(`media/company?path=${path}`, {
      category
    });

    if (data.message === "You are not authorized for this page") {
      navigation("/");
    } else if (data.length == 0) {
      setLoading(false);
      setStateData("No sites found");
      setMainData([]);
      setFilterData([]);
      setSelectedRows([]);
      setTotal(data.length);
    } else {
      setMainData(data);
      setFilterData(data);
      setTotal(data.length);
      setLoading(false);
      setSelectedRows([]);
      clearState();
    }
   

  };


   // store filter input
   const handleChange = (event) => {
    const { name, value } = event;
 
    setFilter((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Perform filtering based on user's input
  const handleSearch = () => {
    const filteredData = mainData.filter((data) => {

      // Apply filters based on the user's input
      if (filter.subcategory && data.subcategory !== filter.subcategory) {
        return false;
      }
      if (filter.illumination && data.illumination !== filter.illumination) {
        return false;
      }
      ///location reset
      if (filter.city_name && data.city_name !== filter.city_name) {
        return false;
      }
      if (filter.location && data.location !== filter.location) {
        return false;
      }
      if (filter.keyword && data.keyword  !== filter.keyword ) {
        return false;
      }
      return true;
    });
    setFilterData(filteredData);
    setTotal(filteredData.length);
    if(filteredData.length==0){
      setStateData("No sites found");
    }
  };

  useEffect(() => {
    handleSearch();
  }, [filter]);


   // Get Current Posts (Pagination)
   const indexOfLastPage = page * postPerpage;
  
   const indexOfFirstPage = indexOfLastPage - postPerpage;
  
   const currentPosts = filterData.slice(indexOfFirstPage, indexOfLastPage);


  let cityies;
  const allCity = mainData.map((city_name) => city_name.city_name);
  cityies = [...new Set(allCity)];

  let subCategory;
  const allsubcategory = mainData.map((subcategory) => subcategory.subcategory);
  subCategory = [...new Set(allsubcategory)];

  let subKeyword;
  let selectlocation;
  const filteredDataLocation = mainData.filter(location => location.city_name === filter.city_name);
  const alllocation = filteredDataLocation.map(location => location.location);
  selectlocation = [...new Set(alllocation)];
  const allsubkeyword = filteredDataLocation.map((key) => key.keyword);
  subKeyword = [...new Set(allsubkeyword)];


  let illumations;
  const allIllumantion = mainData.map(
    (Illumination) => Illumination.illumination
  );
  illumations = [...new Set(allIllumantion)];
  
  let City = [];

  cityies.forEach((obj) => {
    City.push({ label: obj, value: obj,name: "city_name" });
  });

  let Allselectlocation = [];
  selectlocation.forEach((obj) => {
    Allselectlocation.push({ label: obj, value: obj ,name: "location"});
  });


  

  let AllsubCategory = [];
  subCategory.forEach((obj) => {
    AllsubCategory.push({ label: obj, value: obj ,name: "subcategory"});
  });
  
  let Allillumations = [];
  illumations.forEach((obj) => {
      Allillumations.push({ label: obj, value: obj ,name: "illumination"});
  });

  let AllKeywords= [];
  subKeyword.forEach((obj) => {
   
      AllKeywords.push({ label: obj, value: obj,name: "keyword" });
    
  });



  const subcategoryChangeHandler = (value) => {
   
  };
  // const ShowCompany = async () => {
  //   const { data } = await instance.get(`media/company?path=${path}`);
    
  // };

 

  let Comp = [];

  let MediaOption = [
    { label: "traditional-ooh-media", value: "traditional-ooh-media" },
    {
      label: "digital-media",
      value: "digital-media",
    },
    {
      label: "transit-media",
      value: "transit-media",
    },
    {
      label: "mall-media",
      value: "mall-media",
    },
    {
      label: "airport-media",
      value: "airport-media",
    },
    {
      label: "inflight_media",
      value: "inflight_media",
    },
    {
      label: "office-media",
      value: "office-media",
    },
  ];

  const mediaRef = useRef(null);
  const mediaCompanyRef = useRef(null);
  const subcategoryRef = useRef(null);

  const mediaFormRef = useRef(null);
  const mediaCompanyFormRef = useRef(null);
  const subcategoryFormRef = useRef(null);

  const switchTab = (e, tab) => {
    if (tab === "media") {
      mediaFormRef.current.classList.remove("userProfileHidden");
      mediaCompanyFormRef.current.classList.add("userProfileHidden");
      subcategoryFormRef.current.classList.add("userProfileHidden");
      clearState();
      mediaRef.current.classList.add("navActive");
      mediaCompanyRef.current.classList.remove("navActive");
      subcategoryRef.current.classList.remove("navActive");
      setSelectedRows([])
      setMainData([]);
      setFilterData([]);
      setCategory({});
    }

    if (tab === "subcategory") {
      mediaFormRef.current.classList.add("userProfileHidden");
      mediaCompanyFormRef.current.classList.add("userProfileHidden");
      subcategoryFormRef.current.classList.remove("userProfileHidden");
      clearState();
      setCategory({});
      fetchUsers([]); 
      setMainData([]);
      setSelectedRows([])
      mediaRef.current.classList.remove("navActive");
      mediaCompanyRef.current.classList.remove("navActive");
      subcategoryRef.current.classList.add("navActive");
    }
  };
 const restFilter=()=>{
     setSelectedRows([])
      setMainData([]);
      setFilterData([]);
      clearState();
      setCategory({});
 }

  const clearState = () => {
    setFormData({
      code: "",
      company: "",
    });
    setFilter(filterForm);
    setStateData("");
   
    setSubCategory({});
    setIllu({});
    setCity({});
    setLocation({});
    setKeyword({});
  };


  const clearLocKey=()=>{
    setLocation({});
    setKeyword({});
    setFilter((prevFilter) => ({
      ...prevFilter,
      location: "",
      keyword: ""
  }));
  
  }
  const form1Ref = useRef(null);
  const form2Ref = useRef(null);

  const btn1Ref = useRef(null);
  const btn2Ref = useRef(null);
  const btn3Ref = useRef(null);

  useEffect(() => {
    if (formData?.code) {
      form2Ref.current.disabled = true;

      btn2Ref.current.disabled = true;
      btn3Ref.current.disabled = true;
    } else {
      form2Ref.current.disabled = false;
      btn2Ref.current.disabled = false;
      btn3Ref.current.disabled = false;
    }
  }, [formData?.code]);

  const ShowDetails = async (detail) => {
    setLoading(true);
    fetchUsers([]);
    //Main Api to get Data
    const { data } = await instance.post(
      `media/inventory?path=${path}`,
      detail
    );
    if (data.res.length == 0) {
      setStateData("No sites found");
      setLoading(false);
    } else {
      fetchUsers(data.res);
      setLoading(false);
      setTotal(data.res.length)
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (formData?.code) {
      ShowDetails(formData);
    }

  };

  let columns = [
    { dataField: "code", text: "ID" ,headerStyle:{fontSize:"10px"},style:{fontSize:"10px"}},
    { dataField: "thumb", formatter: imageFormatter, text: "Image" ,headerStyle:{fontSize:"10px"}},
    { dataField: "city_name", text: "City",headerStyle:{fontSize:"10px"},style:{fontSize:"10px"}, sort: true },
    { dataField: "location", text: "Location",headerStyle:{fontSize:"10px"},style:{fontSize:"10px"},  sort: true },
    { 
      dataField: "geoloation", 
      text: "Geoloation", 
      headerStyle:{fontSize:"10px"}, 
      style:{fontSize:"10px"},  
      sort: true,
      formatter: (cell, row) => `lat ${row.latitude} , lon ${row.
        longitude
        }`
    },
    { 
      dataField: "size", 
      text: "Size", 
      headerStyle:{fontSize:"10px"}, 
      style:{fontSize:"10px"},  
      sort: true,
      formatter: (cell, row) => `${row.height} x ${row.
        width
        } ${row.heightunit? row.heightunit: "feet"
      }`
    },
    { dataField: "subcategory", text: "Subcategory",headerStyle:{fontSize:"10px"},style:{fontSize:"10px"},  sort: true },
    { dataField: "illumination", text: "Illumination",headerStyle:{fontSize:"10px"},style:{fontSize:"10px"},  sort: true },
    { dataField: "price", text: "Price",headerStyle:{fontSize:"10px"},style:{fontSize:"10px"},  sort: true },
    { dataField: "mediaownercompanyname", text: "Company",headerStyle:{fontSize:"10px"},style:{fontSize:"10px"},  sort: true },
    { dataField: "mediaownername", text: "Person",headerStyle:{fontSize:"10px"},style:{fontSize:"10px"},  sort: true },
    // { dataField: "email", text: "Email",headerStyle:{fontSize:"10px"},style:{fontSize:"10px"},  sort: true },
    { dataField: "phonenumber", text: "Phone",headerStyle:{fontSize:"10px"},style:{fontSize:"10px"},  sort: true },
  ];

  const filteredColumns = columns.filter(column => excelFilters[column.dataField]);

// Example image formatter function
function imageFormatter(cell) {
  return <img src={cell} style={{ width: "60px", height: "60px" }} />;
}

const headerStyle = (column, colIndex) => {
  return { backgroundColor: colIndex === 0 ? 'green' : 'none' };
};

const csvHeaderStyle = (column, colIndex) => {
  return colIndex === 0 ? { background: 'green', color: 'white' } : null;
};

const handleExportCSV = (next, rows) => {
  const formattedRows = rows.map((row, rowIndex) => {
    if (rowIndex === 0) {
      return {
        ID: 'Formatted ID',
        Image: 'Formatted Image',
        Company: 'Formatted Company',
        City: 'Formatted City',
        Phone: 'Formatted Phone',
        Email: 'Formatted Email',
        Category: 'Formatted Category',
        Subcategory: 'Formatted Subcategory',
        Illumination: 'Formatted Illumination',
        Price: 'Formatted Price',
      };
    }
    return row;
  });

  next(formattedRows);
};


  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: (row, isSelect) => {
      // Update the selectedRows state based on user selection
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        setSelectedRows(
          selectedRows.filter((selectedRow) => selectedRow.code !== row.code)
        );
      }
    },
    onSelectAll: (isSelect, rows) => {
      // Update the selectedRows state based on user selection for all rows
      if (isSelect) {
        setSelectedRows([...rows]);
      } else {
        setSelectedRows([]);
      }
    },
  };

  // / PPT

  // _____________________________________________PPT_______________________________________________________________

  const createPdf = async () => {
  setExportingPpt(true);
    if (state.length > 0 || selectedRows.length > 0) {
      // 1. Create a new Presentation

      let pres = new pptxgen();
      pres.layout = "LAYOUT_4x3";

      // 2. Add a Slide
      let slide1 = pres.addSlide();

      // Image by local URL
      slide1.addImage({ path: "assests/headerppt.jpg", w: "100%", h: "100%" });

      const allData = selectedRows ? selectedRows : state;
      const updatedData = allData.map(item => {
        const { width, height, heightunit } = item;
        const size = `${width}x${height} ${heightunit} (W*H)`;
        return { ...item, size };
      });

      updatedData.map((element) => {
        const slide = pres.addSlide();
        slide.addShape(pptx.shapes.RECTANGLE, {
          x: 0.25,
          y: 2.25,
          w: 5.5,
          h: 4.5,
          fill: { color: "FFFFFF" },
          shadow: {
            type: "outer",
            angle: 45,
            blur: 5,
            offset: 2,
            color: "808080",
          },
        });
        const proxyUrl = "https://cors-anywhere.herokuapp.com/";
        const imageUrl = proxyUrl + element.thumb;
        slide.addImage({
          path: imageUrl,
          w: "50%",
          h: "50%",
          x: "5%",
          y: "35%",
        });

        let textboxText = [
          {
            text: "Media Type :" + element.category_name + "",
            options: { fontSize: 20, color: "000000", breakLine: true },
          },
        ];

        let textboxText3 = [
          {
            text: "SITE",
            options: { fontSize: 20, color: "000000", breakLine: true },
          },
        ];
        
        let textboxText4 = Object.entries(pptFilters)
          .filter(([key, value]) => value)
          .map(([key]) => ({
            text: `${key.charAt(0).toUpperCase() + key.slice(1)}: ${element[key]}`,
            options: { fontSize: 15, color: "000000", breakLine: true },
          }));
        
        slide.addShape(pptx.shapes.RECTANGLE, {
          x: "0%",
          y: "0%",
          w: "100%",
          h: "20%",
          fill: { color: "FFFF00" },
          line: { type: "none" },
        });
        slide.addText(textboxText, {
          w: "100%",
          h: "20%",
          x: "3%",
          y: "0%",
          fontSize: 24,
        });
        slide.addText(textboxText3, {
          w: "20%",
          h: "20%",
          x: "75%",
          y: "3%",
          fontSize: 24,
        });
        slide.addText(textboxText4, {
          w: "35%",
          h: "20%",
          x: "65%",
          y: "38%",
          fontSize: 16,
        });
        slide.addShape(pptx.shapes.RECTANGLE, {
          x: "60%",
          y: "10%",
          w: "0.2%",
          h: "80%",
          fill: { color: "000000" },
          line: { type: "none" },
        });
        slide.addShape(pptx.shapes.RECTANGLE, {
          x: "62%",
          y: "20%",
          w: "1.5%",
          h: "35%",
          fill: { color: "FFFF00" },
          line: { type: "none" },
        });
        slide.addShape(pptx.shapes.RECTANGLE, {
          x: "65%",
          y: "80%",
          w: "30%",
          h: "2%",
          fill: { color: "000000" },
          line: { type: "none" },
        });
        slide.addImage({
          path: "assests/logopng.png",
          w: "20%",
          h: "5%",
          x: "70%",
          y: "85%",
        });
      });

      let slide3 = pres.addSlide();
      slide3.addImage({ path: "assests/footerppt.jpg", w: "100%", h: "100%" });
      await pres.writeFile();
      setExportingPpt(false);
    } else {
      alert("First Select any row");
      setExportingPpt(false);
    }
  };

  const createXlsx = async () => {
  setExportingExcl(true);
    try {
      if (state.length > 0 || selectedRows.length > 0) {
        const allData = selectedRows ? selectedRows : state;
        
        const response = await makeXlSX(allData);
        if (response.success) {
          window.open('https://gohadmin.gohoardings.com/download', '_blank');
          setExportingExcl(false);
        } else {
          setExportingExcl(false);
          console.log(response.message);
        }
      } else {
         alert("First Select any row");
        setExportingExcl(false);
      }
    } catch (error) {
      console.log('Error:', error);
       setExportingExcl(false);
    }
  };


  
  return (
    <>
      <div className="containers">
        <div className="container-sidebar">
          <SideBar />
        </div>
        <div className="container-pages">
          <div className="page-title">
            <h2>Media Inventory</h2>
          </div>

          <div className="permissionFilters">
            <div className="permissionFilter">
              <div
                className="existUser navActive"
                ref={mediaRef}
                onClick={(e) => switchTab(e, "media")}
              >
                <strong>Media Code</strong>
              </div>
              <div
                className="newPermission d-none"
                ref={mediaCompanyRef}
                onClick={(e) => switchTab(e, "company")}
              >
                <strong>Media Company's</strong>
              </div>
              <div
                className="newPermission "
                ref={subcategoryRef}
                onClick={(e) => switchTab(e, "subcategory")}
              >
                <strong>Media Category</strong>
              </div>
              
             
            </div>
            <div className="permissionRole" ref={mediaFormRef}>
              <form className="form" onSubmit={submitHandler}>
                <div>
                  <label for="search">Media Code :</label>
                  <input
                    type="text"
                    id="search"
                    name="code"
                    value={formData.code}
                    placeholder="media code .."
                    onChange={changeHandler}
                    autoFocus
                    ref={form1Ref}
                    required
                  />
                </div>
                <input type="submit" value={"Search"} ref={btn1Ref} />
              </form>
            </div>
            <div
              className="permissionRole userProfileHidden d-none"
              ref={mediaCompanyFormRef}
            >
              <form className="form" onSubmit={submitHandler}>
                <div className="w-50 ">
                  <Select
                    onChange={subcategoryChangeHandler}
                    isMulti
                    name="mediaSubcategories"
                    options={Comp}
                    ref={form2Ref}
                    className="basic-multi-select p-2"
                    classNamePrefix="select"
                    required
                  />
                </div>

                <input type="submit" value={"Search"} ref={btn2Ref} />
              </form>
            </div>
            <div
              className="permissionRole userProfileHidden"
              ref={subcategoryFormRef}
            >
               <button className="btn btn-danger " onClick={restFilter}>Reset <BiReset /></button>
              <form className="form" >
                <div className="subcategoryform">
                  <label>Category:</label>
                  <Select
                    options={MediaOption}
                    value={category}
                    onChange={(e)=>showMedia(e)}
                    required
                  />
                </div>
                <div className="subcategoryform">
                  <label>Subcategory:</label>
                  <Select
    value={subcategory}
    onChange={(e) => {
        handleChange(e); 
        setSubCategory(e); 
    }}
    options={AllsubCategory}
    className="basic-multi-select"
    classNamePrefix="select"
/>

                </div>
                <div className="subcategoryform">
                  <label for="type">Illimination:</label>
                  <Select
                  
                    value={Illu}
                    options={Allillumations}
                    onChange={(e) => {
                      handleChange(e); 
                      setIllu(e); 
                  }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
                
                <div className="subcategoryform">
                  <label>City:</label>
                  <Select
                    onChange={(e) => {
                      handleChange(e); 
                      setCity(e); 
                      clearLocKey();
                  }}
                  value={city}
                    options={City}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
                <div className="subcategoryform">
                  <label>Location (city-based):</label>
                  <Select
                   
                    options={Allselectlocation}
                    onChange={(e) => {
                      handleChange(e); 
                      setLocation(e); 
                  }}
                  value={location}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
               
                <div className="subcategoryform">
                  <label>Keywords (city-based):</label>
                  <Select
                    onChange={(e) => {
                      handleChange(e); 
                      setKeyword(e); 
                  }}
                  
                   value={keyword}
                    options={AllKeywords}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>

                <input
                  type="submit"
                  value={"Search"}
                  style={{ margin: "auto 0px 20px 0", display: "none" }}
                  ref={btn3Ref}
                />
              </form>
            </div>
          </div>

          <section className="media-result mt-4">
            {loading ? (
              <Loader />
            ) : (
              <>
                {Users.length > 0 || filterData.length > 0  ? (
                  <>
                   <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
                    <ToolkitProvider
                      keyField="code"
                      data={currentPosts.length > 0 ? currentPosts : Users}
                      columns={filteredColumns}
                      exportCSV={{ onlyExportSelection: true, exportAll: true }}
                    >
                      {(props) => (
                        <div>
                          <ExportCSVButton onClick={createXlsx} classname="me-2">
                          {exportingExcl? "Exporting..." : "Export Excel"} 
                          </ExportCSVButton>
                          <ExportCSVButton onClick={createPdf}>
                           {exportingPpt? "Exporting..." : "Export PPT"} 
                          </ExportCSVButton>
                          <hr />

                          <div>
      <div >
         {/* <h3 className="my-3">Select Columns for Excel:</h3>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.code}
            onChange={() => handleExcelCheckboxChange('code')}
          />
          ID
        </label>*/}
        {/* <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.state}
            onChange={() => handleExcelCheckboxChange('state')}
          />
          State
        </label> */}
          {/*   <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.category_name}
            onChange={() => handleExcelCheckboxChange('category_name')}
          />
          Category
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.city_name}
            onChange={() => handleExcelCheckboxChange('city_name')}
          />
          City
        </label>
     
		        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.location}
            onChange={() => handleExcelCheckboxChange('location')}
          />
          Location
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.geoloation}
            onChange={() => handleExcelCheckboxChange('geoloation')}
          />
          Geoloation
        </label>
		    <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.size}
            onChange={() => handleExcelCheckboxChange('size')}
          />
          Size
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.illumination}
            onChange={() => handleExcelCheckboxChange('illumination')}
          />
          Illumination
        </label>
		    <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.subcategory}
            onChange={() => handleExcelCheckboxChange('subcategory')}
          />
          Subcategory
        </label>
		<label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={excelFilters.price}
            onChange={() => handleExcelCheckboxChange('price')}
          />
          Price
        </label>*/}
      </div>

      <div className="mb-5">
        <h3 className="my-3">Select Options for PowerPoint:</h3>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={pptFilters.code}
            onChange={() => handlePptCheckboxChange('code')}
          />
          ID
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={pptFilters.category_name}
            onChange={() => handlePptCheckboxChange('category_name')}
          />
          Category
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={pptFilters.city_name}
            onChange={() => handlePptCheckboxChange('city_name')}
          />
          City
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={pptFilters.location}
            onChange={() => handlePptCheckboxChange('location')}
          />
          Location
        </label>
		{/*         <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={pptFilters.geolocation}
            onChange={() => handlePptCheckboxChange('geolocation')}
          />
          Geolocation
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={pptFilters.size}
            onChange={() => handlePptCheckboxChange('size')}
          />
          Size
        </label>*/}
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={pptFilters.illumination}
            onChange={() => handlePptCheckboxChange('illumination')}
          />
          Illumination
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={pptFilters.subcategory}
            onChange={() => handlePptCheckboxChange('subcategory')}
          />
          Subcategory
        </label>
		<label  style={{ marginRight: '15px' }}>
          <input
          className="me-1"
            type="checkbox"
            checked={pptFilters.price}
            onChange={() => handlePptCheckboxChange('price')}
          />
          Price
        </label>
      </div>
    </div>
                 
                          <BootstrapTable
                            {...props.baseProps}
                            selectRow={selectRow}
                            noDataIndication="Table is Empty"
                          />

                          <Pajination
                          setPostPerPage={setPostPerPage}
                          postPerpage={postPerpage}
                          page={page}
                          setPage={setPage}
                          total={total}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </>
                ) : (
                  <>
                    <hr />
                    <h1>{noStateData}</h1>
                  </>
                )}
              </>
            )}
          </section>
        </div>
      </div>
    </>
  );
};

export default Media;
